
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/text-to-image-ai",
      function () {
        return require("private-next-pages/text-to-image-ai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/text-to-image-ai"])
      });
    }
  